import React from 'react';
import { useTranslation } from 'react-i18next';
import BubbleButton from '../../../Buttons/BubbleButton/BubbleButton';
import styles from './ContactPopup.module.css';

/**
 * ContactForm component for the talent contact popup
 */
const ContactForm = ({ 
  option, 
  message, 
  sending, 
  error, 
  onOptionChange, 
  onMessageChange, 
  onSubmit, 
  onCancel 
}) => {
  const { t } = useTranslation();

  return (
    <>
      <p className={styles.description}>
        {t('ContactPopup.description')}
      </p>
      
      <form onSubmit={onSubmit} className={styles.form}>
        <div className={styles.options}>
          <div className={styles.option}>
            <input 
              type="radio" 
              id="reveal" 
              name="contactOption" 
              value="reveal" 
              checked={option === 'reveal'} 
              onChange={onOptionChange}
            />
            <label htmlFor="reveal">{t('ContactPopup.reveal_contact')}</label>
          </div>
          
          <div className={styles.option}>
            <input 
              type="radio" 
              id="email" 
              name="contactOption" 
              value="email" 
              checked={option === 'email'} 
              onChange={onOptionChange}
            />
            <label htmlFor="email">{t('ContactPopup.send_email')}</label>
          </div>
        </div>
        
        {option === 'email' && (
          <div className={styles.messageArea}>
            <label htmlFor="message">{t('ContactPopup.message_label')}</label>
            <textarea 
              id="message"
              value={message}
              onChange={onMessageChange}
              placeholder={t('ContactPopup.message_placeholder')}
              rows={5}
            />
          </div>
        )}
        
        {error && <p className={styles.error}>{error}</p>}
        
        <div className={styles.buttons}>
          <BubbleButton 
            type="button" 
            onClick={onCancel}
            headerButton
          >
            {t('general.UI.cancel')}
          </BubbleButton>
          
          <BubbleButton 
            type="submit" 
            disabled={!option || sending}
            dark 
            headerDarkButton
          >
            {sending ? t('general.UI.sending') : t('general.UI.submit')}
          </BubbleButton>
        </div>
      </form>
    </>
  );
};

export default ContactForm; 